import {Component} from 'lowkey-component'
import Swiper, {Mousewheel} from 'swiper'

import {MediaQuery} from '@services/MediaQuery'

export class EngineerBase extends Component {
  private swiper: Swiper | null = null;
  private mq = MediaQuery.create();

  didMount() {
    this.swiper = new Swiper(this.element, {
      modules: [Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 27,
      grabCursor: true,
      slidesOffsetBefore: 32,
      slidesOffsetAfter: 32,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 32,
          slidesOffsetBefore: 0,
        },
      },
    });
  }

  didUnmount() {
    this.swiper?.destroy();
  }
}
